export const WAITING_DELAY_MS = 6000;
export const WAITING_TEXT = 'Je vérifie les différentes possibilités pour vous proposer une réponse adaptée. Encore quelques instants.';

export function scheduleWaitingNotice({load, play, dispose = () => {}, isCurrent = () => true,
  delay = WAITING_DELAY_MS, schedule = setTimeout, clear = clearTimeout}) {
  let cancelled = false;
  let cleanup = null;
  const stopPlayback = () => { const stop = cleanup; cleanup = null; stop?.(); };
  const timer = schedule(async () => {
    if (cancelled || !isCurrent()) return;
    let reply;
    try {
      reply = await load();
      if (cancelled || !isCurrent()) { dispose(reply); return; }
      cleanup = play(reply) || null;
      if (cancelled) stopPlayback();
    } catch {
      if (reply) dispose(reply);
      // The waiting message is optional; the actual request must keep running.
    }
  }, delay);
  return () => {
    if (cancelled) return;
    cancelled = true;
    clear(timer);
    stopPlayback();
  };
}
